var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.704102,
    y: 0.653809,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#3D1E59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_4975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7041 21.6538H11.0374M21.7041 9.65381V10.9871M32.3708 21.6538H33.7041M13.1708 13.1205L14.1041 14.0538M30.2374 13.1205L29.3041 14.0538M18.6374 28.3205H24.7708M17.7041 26.9871C16.5847 26.1476 15.7579 24.9772 15.3407 23.6416C14.9235 22.306 14.9371 20.873 15.3795 19.5456C15.822 18.2182 16.6709 17.0637 17.806 16.2455C18.9411 15.4274 20.3049 14.9871 21.7041 14.9871C23.1033 14.9871 24.4671 15.4274 25.6022 16.2455C26.7373 17.0637 27.5862 18.2182 28.0287 19.5456C28.4711 20.873 28.4847 22.306 28.0675 23.6416C27.6503 24.9772 26.8235 26.1476 25.7041 26.9871C25.1835 27.5025 24.7916 28.1331 24.5599 28.828C24.3283 29.5229 24.2635 30.2625 24.3708 30.9871C24.3708 31.6944 24.0898 32.3727 23.5897 32.8728C23.0896 33.3729 22.4113 33.6538 21.7041 33.6538C20.9969 33.6538 20.3186 33.3729 19.8185 32.8728C19.3184 32.3727 19.0374 31.6944 19.0374 30.9871C19.1447 30.2625 19.0799 29.5229 18.8483 28.828C18.6166 28.1331 18.2247 27.5025 17.7041 26.9871Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_4975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(5.7041 5.65381)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.babfccba63ef9659f84957750f978807.svg";
export { ForwardRef as ReactComponent };